/* eslint-disable react/forbid-elements */
import React from 'react';
import { newLineToBreak } from '../../../utils/htmlHelper';
import { IconRemoveButton } from '../../common/iconButtons/IconRemoveButton';
import { DisplayMarkdown } from '../../common/markdown/DisplayMarkdown';
import { NullableFormattedDate } from '../../utils/NullableFormattedDate';
import { NullableFormattedTime } from '../../utils/NullableFormattedTime';

export function Comment(props: {
    id: string;
    text: string;
    commentedBy: string;
    commentedOn: string;
    onDeleted?: null | ((commentId: string) => void);
    shouldDisplayAsMarkdown?: boolean;
}) {
    return (
        <div className="pn mn">
            <div className="talk-bubble tri-right left-in">
                <div className="talktext">
                    {props.shouldDisplayAsMarkdown && <DisplayMarkdown markdown={props.text ?? ''} />}
                    {!props.shouldDisplayAsMarkdown && <p>{newLineToBreak(props.text)}</p>}
                    <span className="fs10 text-primary-darker">
                        {props.commentedBy}. <NullableFormattedDate value={props.commentedOn} /> - <NullableFormattedTime value={props.commentedOn} />
                        {props.onDeleted && <IconRemoveButton onClick={() => props.onDeleted!(props.id)} />}
                    </span>
                </div>
            </div>
        </div>
    );
}
